if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      if (this.slides.length < 2) return;
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
      this.visible = true;
      this.hovered = false;
      this.querySelector('[data-controls]').hidden = false;
      this.toggle = this.querySelector('[data-toggle]');
      this.status = this.querySelector('[data-status]');
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true), options));
      this.toggle.addEventListener('pointerdown', () => { this.toggleIntent = !this.paused; }, options);
      this.toggle.addEventListener('click', () => {
        this.paused = this.toggleIntent ?? !this.paused;
        this.toggleIntent = null;
        this.sync();
      }, options);
      this.addEventListener('focusin', () => { this.paused = true; this.sync(); }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('keydown', event => {
        const keys = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        this.go(keys[event.key], true);
      }, options);
      this.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' || event.target.closest('button')) return;
        this.pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, options);
      this.addEventListener('pointerup', event => {
        const start = this.pointerStart;
        this.pointerStart = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
      }, options);
      this.addEventListener('pointercancel', () => { this.pointerStart = null; this.toggleIntent = null; }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.15 });
      this.observer.observe(this);
      this.sync();
    }
    go(next, manual = false) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.dataset.activeSlide = String(this.index + 1);
      if (manual) {
        this.paused = true;
        this.status.textContent = this.slides[this.index].getAttribute('aria-label');
      }
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.dataset.paused = String(this.paused);
      this.dataset.playing = String(!this.paused && !this.hovered && this.visible && !document.hidden);
      if (this.dataset.playing === 'true') this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
    }
  });
}
